import { FC } from 'react';
import { StepIconCompleted, StepIconLocked, StepIconPending } from './StepIcons';

interface CompletionStepItemProps {
  status: 'locked' | 'completed' | 'current';
  label: string;
  stepIcon: FC<{ className?: string }>;
  isFocused: boolean;
  onClick: () => void;
}

export const SingleStep: FC<CompletionStepItemProps> = ({
  status,
  label,
  stepIcon: Icon,
  isFocused,
  onClick,
}) => {
  const isCompleted = status === 'completed';
  const isLocked = status === 'locked';
  const isCurrent = status === 'current';

  const baseIcon = isCompleted ? (
    <StepIconCompleted Icon={Icon} />
  ) : isLocked ? (
    <StepIconLocked Icon={Icon} />
  ) : isCurrent ? (
    <StepIconPending Icon={Icon} />
  ) : null;

  const textColorClass = isCompleted
    ? 'text-(--success-S600)'
    : isLocked
      ? 'text-(--neutral-white-NW700)'
      : isCurrent
        ? 'text-(--primary-O1000) font-semibold'
        : 'text-gray-600';

  return (
    <div
      onClick={onClick}
      className="flex w-18 lg:w-40 flex-col items-center relative gap-1 z-1 cursor-pointer"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-(--neutral-white-NW1000)">
        <div
          className={`flex h-10 w-10 md:h-15 md:w-15 items-center justify-center rounded-full border-2 ${
            isFocused ? 'border-(--secondary-B900) bg-(--secondary-B100)' : 'border-transparent'
          }`}
        >
          {baseIcon}
        </div>
      </div>
      <p
        className={`[font-size:var(--fs-l5)]! md:[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! text-center font-medium m-0! leading-tight ${textColorClass}`}
      >
        {label}
      </p>
    </div>
  );
};
